import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';

const ContactTooltip = ({
  id,
  label,
  firstName,
  lastName,
  phoneNumber,
  landlinePhoneNumber,
  placement,
  offset,
}) => {
  const fullName = [firstName, lastName].filter(Boolean).join(' ');
  const details = [fullName, phoneNumber, landlinePhoneNumber].filter(Boolean);

  if (!details.length) {
    return <>{label || '-'}</>;
  }

  return (
    <>
      <span id={id}>{label || '-'}</span>
      <UncontrolledTooltip
        boundariesElement="viewport"
        className="uncontrolled-tooltip"
        delay={0}
        flip={false}
        offset={offset}
        placement={placement}
        target={id}
      >
        {details.map((detail, index) => (
          <React.Fragment key={detail}>
            {index > 0 && <br />}
            {detail}
          </React.Fragment>
        ))}
      </UncontrolledTooltip>
    </>
  );
};

ContactTooltip.defaultProps = {
  label: null,
  firstName: null,
  lastName: null,
  phoneNumber: null,
  landlinePhoneNumber: null,
  placement: 'bottom',
  offset: '',
};

ContactTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  phoneNumber: PropTypes.string,
  landlinePhoneNumber: PropTypes.string,
  placement: PropTypes.string,
  offset: PropTypes.string,
};

export default ContactTooltip;
